// TODO: Normalize ALL Options in the project to (Label and Value) OR (Title and Value) format

// ****************************** YES/ NO ******************************//
export const TypesValidations = {
  YES: 'S',
  NO: 'N',
  NOT_APPLICABLE: 'X'
} as const

export type CustomBoolean = 'S' | 'N'

export enum YesNo {
  YES = 'S',
  NO = 'N'
}

export enum YesNoNotApplicable {
  YES = 'Sim',
  NO = 'Não',
  YES_UPPERCASE = 'SIM',
  NO_UPPERCASE = 'NÃO',
  NotApplicable = 'N/A'
}

export type ValidationOptions = typeof TypesValidations[keyof typeof TypesValidations]

//****************************** COMPANY ******************************//
export enum Company {
  ALPA = 'ALPA'
}

type CompanyType = {
  title: string
  value: Company
}

// TODO: Remove this when the API is ready
export const companies = {
  ALPA: { value: Company.ALPA, title: 'ALPA - Alpargatas S/A' }
}

export const companyOptions: CompanyType[] = [companies.ALPA]

//****************************** ORGANIZATION ******************************//
export enum Organization {
  ALHV = 'ALHV',
  ALOM = 'ALOM'
}

type OrganizationOption = {
  title: Organization
  value: Organization
}

export const organizationOptions: OrganizationOption[] = [
  { title: Organization.ALHV, value: Organization.ALHV },
  { title: Organization.ALOM, value: Organization.ALOM }
]

//****************************** ORDER / OV ******************************//
export enum OVOrder {
  ORDER = 'ORDER',
  OV = 'OV'
}

//****************************** OV TYPES ******************************//
export enum OVTypes {
  YPEM = 'YPEM',
  YRBA = 'YRBA',
  YCPM = 'YCPM',
  YTRA = 'YTRA',
  YHFQ = 'YHFQ',
  YFRQ = 'YFRQ',
  YEXR = 'YEXR'
}

// TODO: Remove this when the API is ready
type OvType = {
  title: OVTypes
  value: OVTypes
}

// TODO: Remove this when the API is ready
export const defaultOvTypeOptions: OvType[] = [
  { title: OVTypes.YPEM, value: OVTypes.YPEM },
  { title: OVTypes.YRBA, value: OVTypes.YRBA },
  { title: OVTypes.YCPM, value: OVTypes.YCPM },
  { title: OVTypes.YTRA, value: OVTypes.YTRA },
  { title: OVTypes.YHFQ, value: OVTypes.YHFQ },
  { title: OVTypes.YFRQ, value: OVTypes.YFRQ },
  { title: OVTypes.YEXR, value: OVTypes.YEXR }
]

//****************************** CHANNELS (MARKETS) ******************************//
export enum Channels {
  MI = 'MI',
  OP = 'OP',
  ME = 'ME'
}

type ChannelOption = {
  title: Channels
  value: Channels
}

export const channelOptions: ChannelOption[] = [
  {
    value: Channels.MI,
    title: Channels.MI
  },
  {
    value: Channels.OP,
    title: Channels.OP
  },
  {
    value: Channels.ME,
    title: Channels.ME
  }
]

//****************************** OFFICES ******************************//
export enum Offices {
  AC60 = 'AC60',
  AESP = 'AESP',
  AH01 = 'AH01',
  AHVA = 'AHVA',
  ALE1 = 'ALE1',
  ALE2 = 'ALE2',
  ALEH = 'ALEH',
  ASMD = 'ASMD'
}

type OfficesOption = {
  label: Offices
  value: Offices
  market?: string
}

export const officeByMarkets = {
  MI: [Offices.AC60, Offices.AESP, Offices.AHVA, Offices.ASMD],
  OP: [Offices.AH01],
  ME: [Offices.ALE1, Offices.ALE2, Offices.ALEH]
}

export const defaultOfficeOptions: OfficesOption[] = [
  { label: Offices.AC60, value: Offices.AC60, market: 'MI' },
  { label: Offices.AESP, value: Offices.AESP, market: 'MI' },
  { label: Offices.AHVA, value: Offices.AHVA, market: 'MI' },
  { label: Offices.ASMD, value: Offices.ASMD, market: 'MI' },
  { label: Offices.AH01, value: Offices.AH01, market: 'OP' },
  { label: Offices.ALE1, value: Offices.ALE1, market: 'ME' },
  { label: Offices.ALE2, value: Offices.ALE2, market: 'ME' },
  { label: Offices.ALEH, value: Offices.ALEH, market: 'ME' }
]

//****************************** CENTERS / FACTORIES ******************************//
export enum CentersFactories {
  A022 = 'A022',
  A026 = 'A026',
  A029 = 'A029',
  A055 = 'A055',
  A133 = 'A133',
  A297 = 'A297'
}

type CentersFactoriesOption = {
  title: CentersFactories
  value: CentersFactories
}

export const defaultFactoryOptions: CentersFactoriesOption[] = [
  { title: CentersFactories.A022, value: CentersFactories.A022 },
  { title: CentersFactories.A026, value: CentersFactories.A026 },
  { title: CentersFactories.A055, value: CentersFactories.A055 },
  { title: CentersFactories.A133, value: CentersFactories.A133 },
  { title: CentersFactories.A297, value: CentersFactories.A297 }
]

export const allFactoriesFilter = [
  { title: CentersFactories.A029, value: CentersFactories.A029 },
  ...defaultFactoryOptions
].sort((a, b) => a.title.localeCompare(b.title))

export const availableCentersFactoriesFilter = [
  { title: 'Todos', value: 'todos' },
  ...defaultFactoryOptions
]

export const availableCentersFactories = Object.values(CentersFactories)

//****************************** SECTORS ******************************//
export enum Sectors {
  AC = 'AC',
  AV = 'AV',
  OM = 'OM'
}

type SectorOption = {
  title: string
  value: Sectors
}

export const sectorOptions: SectorOption[] = [
  {
    value: Sectors.AC,
    title: 'AC - Calçados'
  },
  {
    value: Sectors.AV,
    title: 'AV - Acessórios e Vestuário'
  }
]

export const allSectorOptions = [
  ...sectorOptions,
  { title: 'OM - Omni', value: Sectors.OM }
]

//****************************** UNFOLD ******************************//
export enum Unfold {
  FABRICA = 'Fábrica',
  MATERIAL = 'Material'
}

type UnfoldOption = {
  title: Unfold
  value: typeof TypesValidations[keyof typeof TypesValidations]
}

export const unfoldOptions: UnfoldOption[] = [
  {
    title: Unfold.FABRICA,
    value: TypesValidations.NO
  },
  {
    title: Unfold.MATERIAL,
    value: TypesValidations.YES
  }
]

//****************************** MATERIAL TYPE ******************************//
export enum MaterialType {
  PADRAO = 'Padrão',
  MTO = 'MTO'
}

export enum TypeRuleExceptionStock {
  COR = 'C',
  CONTRAESTOQUE = 'F',
  MATERIAL = 'M',
  SKU = 'S'
}

type MaterialTypeOption = {
  title: MaterialType
  value: typeof TypesValidations[keyof typeof TypesValidations]
}

export const materialTypeOptions: MaterialTypeOption[] = [
  {
    title: MaterialType.PADRAO,
    value: TypesValidations.NO
  },
  {
    title: MaterialType.MTO,
    value: TypesValidations.YES
  }
]

//****************************** ORDER ORIGIN ******************************//
export enum OriginOrder {
  B2B = 'B', // Portal B2B
  HAVA = 'H', // Hava Conecta
  EDI = 'E' // EDI
}

//************************* STATUS ORDER HAVA *************************//
export enum StatusHAVA {
  Opened = 'A', // Aberto
  Finished = 'C' // Concluído
}

//************************* STATUS ORDER/OV EDI *************************//
// TODO: Get real status when backend is ready
export enum StatusEDI {
  Pending = 'P',
  Success = 'S',
  Error = 'E'
}

//****************************** PAYMENT TERMS ******************************//
// NOTE: This codes are from SAP. Any change in the codes in SAP must be updated here.
export enum PaymentTerms {
  AV01 = 'AV01'
}

//****************************** CRITICISM TYPE (STATUS) ******************************//
export enum CriticismType {
  QUOTA = 'COTA',
  STOCK = 'ESTOQUE',
  QUOTA_STOCK = 'COTA/ESTOQUE'
}

type CriticismTypeOption = {
  label: CriticismType
  value: CriticismType
}

export const criticismTypeOptions: CriticismTypeOption[] = [
  { label: CriticismType.QUOTA, value: CriticismType.QUOTA },
  { label: CriticismType.STOCK, value: CriticismType.STOCK },
  { label: CriticismType.QUOTA_STOCK, value: CriticismType.QUOTA_STOCK }
]

//************************* QUOTA LEVELS *************************//
export enum QuotaLevel {
  Zone = 'ZON',
  Regional = 'GRV',
  National = 'GNV',
  NotApplicable = 'N/A'
}

//****************************** ND STATUS TYPE ******************************//
export type StatusNdType = 'pending' | 'justified' | 'approved'

//****************************** PRODUCTION TYPE ******************************//
export enum ProductionType {
  OUT_OF_LINE = 'FORA DE LINHA',
  IN_LINE = 'EM LINHA'
}

type ProductionTypeOption = {
  title: ProductionType
  value: typeof TypesValidations[keyof typeof TypesValidations]
}

export const productionTypeOptions: ProductionTypeOption[] = [
  { title: ProductionType.OUT_OF_LINE, value: TypesValidations.YES },
  { title: ProductionType.IN_LINE, value: TypesValidations.NO }
]

//************************* ORDER BLOCKERS *************************//
export enum OrderBlockers {
  ZONE = 'ZONA',
  GRV = 'GRV',
  GNV = 'GNV'
}

//****************************** CUSTOMER TYPE ******************************//
export enum CustomerType {
  PJ = 'J', // Pessoa Jurídica
  PF = 'F' // Pessoa Física
}

type CustomerTypeOption = {
  title: string
  value: CustomerType
}

export const customerTypeOptions: CustomerTypeOption[] = [
  { title: 'Pessoa Jurídica', value: CustomerType.PJ },
  { title: 'Pessoa Física', value: CustomerType.PF }
]
